import { render, staticRenderFns } from "./approval-dialog.vue?vue&type=template&id=3da31510&"
import script from "./approval-dialog.vue?vue&type=script&lang=js&"
export * from "./approval-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports